/** ShareButton 스타일 — "Link copied" 는 버튼 왼쪽에 잠깐 선다 */
export const shareButtonStyles = {
  root: "flex items-center gap-[var(--fw-space-gap-sm)]",
  copied: "fw-caption text-[var(--fw-color-content-neutral-tertiary)]",
};
